import Vue from 'vue';
import Vuex from 'vuex';
import flatpickr from "flatpickr";


Vue.use(Vuex);

var store  = new Vuex.Store({
    modules: {
    },
});

window.axios = require('axios');

Vue.component('valuation-tool', require('./ValuationTool.vue'));

const app = new Vue({
    el: '#valuationTool',
    data: {},
    mixins: [{
        methods: {
            flatpickr
        }
    }],
    store,
});


// WEBPACK FOOTER //
// ./resources/assets/js/valuation-tool/valuation-tool.js